export const ADD_APD_ITEM = 'ADD_APD_ITEM';
export const ADD_APD_YEAR = 'ADD_APD_YEAR';
export const APD_ACTIVITIES_CHANGE = 'APD_ACTIVITIES_CHANGE';
export const EDIT_APD = 'EDIT_APD';
export const EDIT_APD_NAME = 'EDIT_APD_NAME';
export const REMOVE_APD_ITEM = 'REMOVE_APD_ITEM';
export const REMOVE_APD_YEAR = 'REMOVE_APD_YEAR';
export const UPLOAD_FILE_FAILURE = 'UPLOAD_FILE_FAILURE';
export const UPLOAD_FILE_REQUEST = 'UPLOAD_FILE_REQUEST';
export const UPLOAD_FILE_SUCCESS = 'UPLOAD_FILE_SUCCESS';
